import './app.css';
import { brandStore } from '@/lib/brandStore.svelte';
import { initRouter } from '@/lib/router';
import { mount } from 'svelte';
import App from './App.svelte';
import { DetectionTracker } from '@/lib/detectionTracker';

async function bootstrap() {
  await brandStore.init();
  initRouter();

  window.__DT__ = { DetectionTracker };

  mount(App, { target: document.getElementById('app')! });
}

bootstrap();
